// modules
import { handleActions } from 'redux-actions'

// actions
import {
  setPatientMedicalDeviceOrderingList,
  setPatientMedicalDeviceOrderingEditOrder,
  setPatientMedicalDeviceOrderingTypeList,
  resetPatientMedicalDeviceOrdering
} from 'src/store/modules/patient/medicalDevices'

const initialState = {
  orderList: [],
  editOrder: {},
  medicalDeviceTypeList: []
}

export default handleActions(
  {
    [setPatientMedicalDeviceOrderingList](state, { payload: orderList }) {
      return {
        ...state,
        orderList
      }
    },

    [setPatientMedicalDeviceOrderingEditOrder](state, { payload: editOrder }) {
      return {
        ...state,
        editOrder
      }
    },

    [setPatientMedicalDeviceOrderingTypeList](
      state,
      { payload: medicalDeviceTypeList }
    ) {
      return {
        ...state,
        medicalDeviceTypeList
      }
    },

    [resetPatientMedicalDeviceOrdering]() {
      return initialState
    }
  },
  initialState
)
